import { render, staticRenderFns } from "./CarouselList.vue?vue&type=template&id=4d982946&scoped=true"
import script from "./CarouselList.vue?vue&type=script&lang=js"
export * from "./CarouselList.vue?vue&type=script&lang=js"
import style0 from "./CarouselList.vue?vue&type=style&index=0&id=4d982946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d982946",
  null
  
)

export default component.exports